import { useState, useEffect } from 'react'
import { useMemoizedFn, useDocumentVisibility } from 'ahooks'
import { canIUse, getPrivacyInfo } from '@bcz/fe-interface'

/**
 * 判断是否已开启系统通知？
 */
export function useNotifPushState() {
  const docViz = useDocumentVisibility()
  const [notifPushTurnedOn, setNotifPushTurnedOn] = useState(true)

  // 自动确定是否需要展示 `设置学习提醒` 提示
  const autoCheck = useMemoizedFn(() => {
    if (canIUse('getPrivacyInfo')) {
      ~(async () => {
        try {
          const { result } = await getPrivacyInfo({
            features: [getPrivacyInfo.feature.Notification],
          })
          setNotifPushTurnedOn(
            result[getPrivacyInfo.feature.Notification] === getPrivacyInfo.grantStatus.Granted,
          )
        } catch (err) {
          setNotifPushTurnedOn(true)
        }
      })()
    } else {
      setNotifPushTurnedOn(true)
    }
  })

  useEffect(() => {
    if (docViz === 'visible') {
      autoCheck()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [docViz])

  return { notifPushTurnedOn }
}
